import { NA_VALUE } from "@/const/default-values"
import { ShowMore } from "@/molecules/ShowMore"
import { ConnectionStatusLabel } from "@/pages/DeploymentsPage/components/molecules/CloudConnectionStatus"

import styles from "./StatusCell.module.scss"

import type { CloudConnectionStatusCellProps } from "./StatusCell.types"

const KEY_PREFIX = "deployments.cloudConnection"

// A cloud connection's status, with its last sync on hover, as the live
// Violations cell details its count
export const CloudConnectionStatusCell = ({
  status,
  record,
  t
}: CloudConnectionStatusCellProps) => (
  <ShowMore
    id={`cloud-connection-${record.key}`}
    label={
      <ShowMore.Label.Component>
        <ConnectionStatusLabel status={status} />
      </ShowMore.Label.Component>
    }
  >
    <ShowMore.Component
      title={t(`${KEY_PREFIX}.sync`)}
      classes={{ content: styles.sync }}
    >
      <ShowMore.Description
        items={[
          {
            label: t(`${KEY_PREFIX}.fields.lastSync`),
            value: record.lastHeartbeatTime || t("general.never")
          },
          {
            label: t(`${KEY_PREFIX}.fields.agents`),
            value: `${record.agentsCount ?? NA_VALUE}`
          },
          // The platform's reasons, one a line
          ...(record.statusReason
            ? [
                {
                  label: t(`${KEY_PREFIX}.fields.statusReason`),
                  value: record.statusReason.split("; ").join("\n")
                }
              ]
            : [])
        ]}
      />
    </ShowMore.Component>
  </ShowMore>
)
